import { render } from "./dermatology_list.vue?vue&type=template&id=1f2289ee&scoped=true"
import script from "./dermatology_list.vue?vue&type=script&lang=js"
export * from "./dermatology_list.vue?vue&type=script&lang=js"

import "./dermatology_list.vue?vue&type=style&index=0&id=1f2289ee&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2289ee"]])

export default __exports__